module.exports = __webpack_public_path__ + "static/year2015-eae73a96d13df4df5e3d9c8a7c1bc911.jpg";